import { render, staticRenderFns } from "./edit-compere-modal.vue?vue&type=template&id=4e603326&scoped=true"
import script from "./edit-compere-modal.vue?vue&type=script&lang=js"
export * from "./edit-compere-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-compere-modal.vue?vue&type=style&index=0&id=4e603326&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e603326",
  null
  
)

export default component.exports